import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const updateUserFavorites = async (foi = null, apiToken = null, removeFromFavorites) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!foi) {
        console.log("no foi");
        return null;
    }
    console.log("CALLING SERVER with updateuserfavorites")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'updateuserfavorites',
            'apiToken': apiToken,
            'foi': foi,
            'remove': removeFromFavorites
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from updateuserfavorites call");
    }).catch((error) => { console.log(error); });
}

export default updateUserFavorites;